import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { sponsorListData } from 'sections/Events/GlobalFreightSummit2023/data';
import { SponsorListItem } from 'sections/Events/GlobalFreightSummit2023/types';
import styles from 'sections/Events/GlobalFreightSummit2023/components/SectionSponsor/SectionSponsor.module.scss';

const cn = classNames.bind(styles);

const SectionSponsor = (): ReactElement => {
  const sponsorListElements = sponsorListData.map((item: SponsorListItem) => {
    return (
      <li className={cn('sponsor__list-item')} key={item.id}>
        <span className={cn('sponsor__list-item-text', 'bold')}>{item.accentText}</span>
        &nbsp;<span className={cn('sponsor__list-item-text')}>{item.text}</span>
      </li>
    );
  });

  return (
    <section className={cn('sponsor')}>
      <div className={cn('container')}>
        <h3 className={cn('sponsor__title')}>Why Sponsor?</h3>
        <ul className={cn('sponsor__list')}>
          {sponsorListElements}
        </ul>
        <p className={cn('sponsor__assistance')}>
          If you have any questions or need further assistance about sponsorship, please contact us by email at{' '}
          <Link className={cn('sponsor__assistance-link')} href="mailto: GFS.Sponsorships@dpworld.com">
            GFS.Sponsorships@dpworld.com
          </Link>
        </p>
      </div>
    </section>
  );
};

export default SectionSponsor;